import { useRoute } from '@react-navigation/native';
import { SxProp, View } from 'dripsy';
import jwt from 'jwt-decode';
import moment from 'moment-timezone';
import React, { useEffect } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import { useStore } from 'store/store';
import { utxAuthRefreshToken } from '@utx/utx-client';
import { iframePostMessage } from '../../../utils/iframePostMessage';
export interface LayoutContextProps {
  children?: React.ReactElement;
  route?: string;
  sx?: SxProp;
}

const minHeight = 700;
export const UtxAppEmbed = (props: LayoutContextProps) => {
  const { height } = useWindowDimensions();
  const store = useStore();
  const screenHeight = height;
  const route = useRoute();
  const onLayout = (e) => {
    if (Platform.OS === 'web' && route.name === props.route) {
      const { height } = e.nativeEvent.layout;
      if (height > 0) {
        let frameHeight = screenHeight;
        if (height < minHeight) {
          frameHeight = minHeight;
        } else {
          frameHeight = height;
        }

        iframePostMessage('resizeIframeMessage', {
          detail: {
            height: frameHeight
          }
        });
      }
    }
  };

  useEffect(() => {
    const expiryInterval = setInterval(checkExpiredAndRefreshToken, 10 * 1000);
    return () => {
      clearInterval(expiryInterval);
    };
  }, []);

  const userInteraction = () => {
    store.lastMoved = new Date();
  };

  const getTokenExpiryInSecond = () => {
    const token = store.authToken;
    const tokenData = jwt(token); // if token invalid, this will throw
    const exp = Number(tokenData.exp);
    const current = Number(new Date()) / 1000;
    const now = Math.round(current);
    return exp - now;
  };

  const getSecondsSinceLastActivity = () => {
    return moment().diff(store.lastMoved, 'second');
  };

  const fetchAccessToken = async () => {
    const authTokenResponse = await utxAuthRefreshToken();
    if (!authTokenResponse) {
      return;
    }

    return authTokenResponse.data.token;
  };

  const checkExpiredAndRefreshToken = async () => {
    const timeLeft = getTokenExpiryInSecond();
    // refreshes if
    // - user has performed anything within last 10 minutes
    // - and token time left is less than 10 minutes

    if (getSecondsSinceLastActivity() <= 1200 && timeLeft <= 1200) {
      const refreshToken = await fetchAccessToken();
      if (refreshToken) {
        store.changeAuthToken(refreshToken);
      }
      return;
    }

    if (timeLeft <= 0) {
      iframePostMessage('logout', true);
      return;
    }
  };

  return (
    <View onTouchStart={userInteraction} onLayout={onLayout} sx={props.sx}>
      {props.children}
    </View>
  );
};
